

export const initialComponentsState = {
    page:             'home',
    textInput:        '',
    success:          false,
    failurCount:      0,
    updateFailCount:  false,
    hideFeedBack:     false,
    draggedBox:       -1,
    animateComp:      false,
    animatePage:      false,
    showPyrotechnics: false,
    showOptionMenu:   false,
    tens: {
        isOver: false,
        value:   -1
    },
    units: { 
        isOver: false,
        value:  -1
    }
}


export const initialModalState = {
    showModal:    false,
    modalVariant: ''
}